import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { SidebarInset } from "../components/ui/sidebar";
import { PullRequestsPage } from "./pullRequests/PullRequestsPage";
import {
  parsePullRequestsSearch,
  type PullRequestsSearch,
} from "./pullRequests/pullRequests.logic";

export const Route = createFileRoute("/_chat/pull-requests")({
  validateSearch: parsePullRequestsSearch,
  component: PullRequestsRouteView,
});

function PullRequestsRouteView() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const handleSearchChange = (next: PullRequestsSearch) => {
    void navigate({ search: next, replace: true });
  };
  return (
    <SidebarInset className="h-full min-h-0 overflow-hidden overscroll-y-none bg-background text-foreground isolate">
      <PullRequestsPage search={search} onSearchChange={handleSearchChange} />
    </SidebarInset>
  );
}
